<template>
  <div id="welcome-header">
    <LoginVariableFont text="Welcome" />
    <div id="line-top" :class="{ animate: animate }"></div>
  </div>
</template>

<script>
import LoginVariableFont from "./LoginVariableFont";

export default {
  name: "LoginOverlayHeader",
  data() {
    return {
      animate: false,
    };
  },
  mounted() {
    if (document.hidden) {
      // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          this.animate = true;
        }
      });
    } else {
      setTimeout(() => {
        this.animate = true;
      }, 1);
    }
  },
  components: {
    LoginVariableFont,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

#welcome-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  #line-top {
    width: 100%;
    height: 25px;
    background-color: $accent;

    transition-property: transform;
    transition-duration: 0.9s;
    transition-timing-function: ease-in-out;

    transform-origin: left;
    transform: scaleX(0);

    &.animate {
      transform: scaleX(1);
    }
  }
}
</style>
